<template>
  <div>
    <div class="p-5 bg-white rounded non-print">
      <div class="pt-6 pb-2 text-xl text-center">{{ $t('customer.current_customer') }}</div>
      <div class="flex justify-end py-3">
        <v-btn class="blue white--text mx-1" @click="exportExcel" :disabled="isLoading" :loading="isLoading">
          <v-icon left>mdi-file-excel</v-icon>Export Excel
        </v-btn>
        <v-btn class="blue white--text mx-1" @click="printPDF">
          <v-icon left>mdi-file-excel</v-icon>{{ $t('print_pdf') }}
        </v-btn>
        <FilterColumnDataTable v-model="headers" @onSuccess="onSelectFilterColumn" dataTableName="ReportActive" />
      </div>
      <div>
        <v-data-table
          v-if="dataTable"
          :headers="dataTable.headers"
          :items="dataTable.data"
          :items-per-page="itemsPerPage"
          class="elevation-1 v-data-table-report data-table-active"
          item-key="objectId"
          v-model="selectedContracts"
          :show-select="isShowSelectContract"
          :single-select="false"
          id="print-report-active"
          :loading="isLoading"
          :no-data-text="$t('noinfo')"
          :no-results-text="$t('no_matching_records_found')">
         
          <template v-slot:header.marketName="{header}">
             <div class="text-nowrap-table market-name" style="min-width:100px">{{header.text}}</div>
          </template>
          <template v-slot:header.areas="{header}">
             <div class="text-nowrap-table area-name" style="min-width:100px">{{header.text}}</div>
          </template>
          <template v-slot:header.customerName="{header}">
             <div class="text-nowrap-table customer-name" style="min-width:150px">{{header.text}}</div>
          </template>
          <template v-slot:header.products="{header}">
             <div class="text-nowrap-table product-name" style="min-width:100px">{{header.text}}</div>
          </template>
          <template v-slot:header.businessName="{header}">
             <div class="text-nowrap-table business-name" style="min-width:100px">{{header.text}}</div>
          </template>

         
          <template v-slot:item.marketName="{ item }">
            <div class="hd-resize text-truncate">
              {{ item.marketName || '-' }}
            </div>
          </template>
          <template v-slot:item.areas="{ item }">
            <div class="hd-resize text-truncate area-name">
              {{ item.areas.map(d => d.name).join(',') || '-' }}
            </div>
          </template>
          <template v-slot:item.customerName="{ item }">
            <div class="hd-resize text-truncate">
              {{ item.customerName || '-' }}
            </div>
          </template>
          <template v-slot:item.products="{ item }">
            <div class="hd-resize text-truncate">
              {{ item.productsJoin || '-' }}
            </div>
          </template>
          <template v-slot:item.businessName="{ item }">
            <div class="hd-resize text-truncate">
              {{ item.businessName || '-' }}
            </div>
          </template>
          <template v-slot:item.contractId="{ item }">
            <div class="text-no-wrap">
              {{ item.contractId || '-' }}
            </div>
          </template>
          <template v-slot:item.totalRecognizance="{ item }">
            <div class="text-no-wrap text-right">{{ item.totalRecognizance || 0 | currencyPrefixSign }}</div>
          </template>
          <template v-slot:item.startDate="{ item }">
            <template v-if="item.startDate">{{ $moment(item.startDate.iso).format("D/MM/YYYY") }}</template>
          </template>
          <template v-slot:item.endDate="{ item }">
            <template v-if="item.endDate">{{ $moment(item.endDate.iso).format("D/MM/YYYY") }}</template>
          </template>
          <template v-slot:item.totalCost="{ item }">
            <div class="text-no-wrap text-right">{{ item.totalCost || 0 | currencyPrefixSign }}</div>
          </template>
        </v-data-table>
      </div>
      <div class="pt-5 text-gray-400 doc">
        {{ $t('note') }} :
        <div class="pl-5">
          - {{ $t('payment.deposit_money_note') }}
        </div>
        <div class="pl-5">
          - {{ $t('payment.rent_and_service_note') }}
        </div>
      </div>
    </div>
    <v-dialog v-model="isContractTemplateDialog" fullscreen class="editor-dialog">
      <DocumentEditorDialog v-if="isContractTemplateDialog" type="edit" :templates="templates" />
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BetweenDate from "./BetweenDate.vue";
import DocumentEditorDialog from "@/components/DocumentEditorDialog.component.vue"
import FilterColumnDataTable from "@/components/FilterColumnDataTable.vue"
import { Excel } from "../exports";
export default {
  components: {
    BetweenDate,
    DocumentEditorDialog,
    FilterColumnDataTable
  },
  computed: {
    ...mapGetters({
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
      invoicesRecognizance: "invoice/getInvoicesRecognizance",
      billingSettings: "billingSetting/getBillingSettings",
      getFullName: "user/getFullName",
      getLastCurrencyRate: "currencyRate/getLastCurrencyRate",
    }),
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    userFullName() {
      return this.getFullName;
    },
    dataTable() {
      return {
        headers: this.headers && this.headers.length ? this.headers.filter(h => h.isShow) : [], // filter(h=>h.isShow == true)
        data: this.contracts && this.contracts.length ? this.contracts : [] // filter(c => c.isActive == true)
      }
    },
    headersLocalStorage() {

    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      isLoadDataExport: false,
      contracts: null,
      isShowSelectContract: false,
      selectedContracts: [],
      project: null,
      market: null,
      templates: null,
      isContractTemplateDialog: false,
      startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
      endDate: this.$moment().endOf("month").format("YYYY-MM-DD"),
      itemsPerPage: 10,
      filterColumnDialog: false,
      headers: []
    };
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }

    this.headers = [
        {
          text: this.$t('market.market'),
          value: "marketName",
          align: "center hd-resize",
          sortable : false,
        },
        {
          text: this.$t('market.market_title'),
          value: "areas",
          align: "center hd-resize area-name",
          sortable : true,
          class : 'custom-sort'
        },
        {
          text: this.$t('market.marchant_name'),
          value: "customerName",
          align: "center hd-resize",
          sortable : false,
        },
        {
          text: this.$t('bill.customer_market_id'),
          value: "customerId",
          align: "center",
          isShow: false
        },
        {
          text: this.$t('product.title'),
          value: "products",
          align: "center hd-resize",
          sortable : false,
        },
        {
          text: this.$t('area.shop_name'),
          value: "businessName",
          align: "center hd-resize",
          sortable : false,
        },
        {
          text: this.$t('customer.customer_tel'),
          value: "customerTel",
          align: "center",
        },
        {
          text: this.$t('payment.deposit_money'),
          value: "totalRecognizance",
          align: "center",
        },
        {
          text: this.$t('contract.start_date'),
          value: "startDate",
          align: "center",
          // width: "15%"
        },
        {
          text: this.$t('contract.end_date'),
          value: "endDate",
          align: "center",
          // width: "15%"
        },
        {
          text: this.$t('contract.contract_number_only'),
          value: "contractId",
          align: "center",
          // width: "20%"
        },
        {
          text: this.$t('payment.rent_and_service_per_month'),
          value: "totalCost",
          align: "center",
        },
    ];
  },
  mounted() {
    this.intiDataTable();
    this.initData();
  },
  methods: {
    ...mapActions({
      getBillingSettingsByAreas: "billingSetting/getBillingSettingsByAreas",
      getInvoicesRecognizanceByContract: "invoice/getInvoicesRecognizanceByContract",
      getActiveContractByMarket: "contract/getActiveContractByMarket"
    }),
    intiDataTable() {
      if (this.headers && this.headers.length) {
        for (let header of this.headers) {
          if (header.isShow === undefined) header.isShow = true
          else header.isShow = false
        }
      }
      this.onSelectFilterColumn(this.headers.filter(h => h.isShow).map(h => h.value))
    },
    onSelectFilterColumn(hs) {
      let resHeaders = []
      let hst = []
      let filterDataTable = localStorage.getItem("filterDataTable");
      filterDataTable = filterDataTable ? JSON.parse(filterDataTable) : null
      let lhs = filterDataTable && filterDataTable['ReportActive'] ? filterDataTable['ReportActive'] : null
      if (lhs && lhs.length) hst = lhs
      else if (hs) hst = hs
      for (let header of this.headers) {
        header.isShow = hst.find(h => h == header.value) ? true : false;
        resHeaders.push(header)
      }
      this.headers = resHeaders
    },
    async initData() {
      this.isLoading = true
      try {
        this.contracts = await this.getActiveContractByMarket({
          marketId: this.marketId,
          isSuspend: true
        })
        let areaIds = [], contractIds = []
        for (const contract of this.contracts) {
          areaIds = [...areaIds, ...contract.areas.map(a => a.objectId)]
          contractIds.push(contract.objectId)
        }
        this.isLoadDataExport = true
        await this.getBillingSettingsByAreas({ areaIds })
        await this.getInvoicesRecognizanceByContract({ contractIds, isToMainCurrency: true })
        let billingSettingByAreaObject = {}
        let invoiceByContractObject = {}
        for (const invoice of this.invoicesRecognizance) {
          if (invoice.contract && !invoiceByContractObject[invoice.contract.objectId]) invoiceByContractObject[invoice.contract.objectId] = 0
          invoiceByContractObject[invoice.contract.objectId] += invoice.totalValue
          if (invoice.refInvoiceBooking?.length)
            for (const refInvoiceBooking of invoice.refInvoiceBooking) {
              invoiceByContractObject[invoice.contract.objectId] += refInvoiceBooking.totalValue
            }
        }
        for (let billingSetting of this.billingSettings) {
          if (billingSetting.type == 'monthly') {
            let exchangeRate = 1
            if (billingSetting.currencyCode != this.$globalCurrencyCode) {
              exchangeRate = this.getLastCurrencyRate.data?.[billingSetting.currencyCode]?.[this.$globalCurrencyCode]?.value || 1
            }
            let total = 0
            let areaId = billingSetting.area.objectId
            if (areaId && !billingSettingByAreaObject[areaId]) billingSettingByAreaObject[areaId] = { data: [], total: 0 }
            let cost = billingSetting.cost ? parseFloat(billingSetting.cost) : 0
            let originalDiscount = billingSetting.originalDiscount ? parseFloat(billingSetting.originalDiscount) : 0
            total = this.$helper.round((cost - originalDiscount) * exchangeRate)
            billingSettingByAreaObject[areaId].total += total
            billingSettingByAreaObject[areaId].data.push(billingSetting)
          }
        }
        for (let contract of this.contracts) {
          contract.products = []
          contract.productsJoin = '-'
          contract.customerName = '-'
          contract.customerTel = '-'
          contract.totalCost = 0
          contract.totalRecognizance = invoiceByContractObject[contract.objectId] ? invoiceByContractObject[contract.objectId] : 0
          contract.marketName = contract.market.name
          if (contract.billingData) {
            contract.customerName = contract.billingData.name
            contract.customerTel = contract.billingData.tel
          }
          if (contract.areas && contract.areas.length)
            for (const area of contract.areas) {
              if (area.objectId && billingSettingByAreaObject[area.objectId])
                contract.totalCost += (billingSettingByAreaObject[area.objectId].total || 0)
              if (area.products && area.products.length)
                for (const product of area.products) {
                  if (product && product.name)
                    contract.products.push(product.name)
                }
            }
          contract.productsJoin = contract.products.join(',')
        }
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        this.$toast.show({
          content: `${this.$t('error')}`,
          color: "error"
        });
      }
    },
    exportExcel() {
      Excel.reportCheckin(this.contracts, this.startDate, this.endDate, this.billingSettings, this.invoicesRecognizance, true)
    },
    printPDF() {
      const tempItemsPerPage = this.itemsPerPage
      this.itemsPerPage = -1
      setTimeout(() => {
        let printReportActive = document.getElementById("print-report-active").innerHTML;
        let printPreviewTopic = document.getElementById("print-preview-topic");
        let printPreviewcontent = document.getElementById("print-preview-content");
        let printPreviewFooter = document.getElementById("print-preview-footer");

        printPreviewTopic.innerHTML = `
          <h2 style="text-align: center;" class="my-4">
            <b>${this.$t('customer.current_customer')}</b>
          </h2>
          <p style="text-align: center;">${this.market.name}</p>
        `
        printPreviewcontent.innerHTML = printReportActive
        printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')} : </b>${this.userFullName} <b>${this.$t('when')}</b> ${this.$moment().format("lll")}</div>`
        window.print();
        this.itemsPerPage = tempItemsPerPage
      }, 200)

    },

  },
};
</script>

<style lang="scss" scoped>
.text-nowrap-table.customer-name {
  // min-width: 100px;
}

.data-table-active::v-deep td {
  max-width: 250px;
}

.data-table-active::v-deep td.hd-resize {
  max-width: 100px;
}

.data-table-active::v-deep td.hd-resize.area-name {
  max-width: 80px;
}

.data-table-active::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}

.doc {
  font-size: 13px;
}
</style>